"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ne = void 0;
const ne = ({ leftValue, rightValue, }) => {
    const result = leftValue !== rightValue;
    return { error: null, result };
};
exports.ne = ne;
//# sourceMappingURL=ne.js.map